(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-message-bottle-carousel"] && !Shopify.designMode) return;
  try {
    
$('.mib-slideshow__container').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: true,
  adaptiveHeight: true
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-message-bottle"] && !Shopify.designMode) return;
  try {
    
// Message in a Bottle Video
jQuery(document).ready(function($) {
    var $video = document.getElementById("video_src");
    $('.play_button, .play_text').on('click', function() {
        $('.video__src')[0].play();
        $('#video').removeClass('has-overlay');
        $('#video').css('display', 'none');

    });
    $('.video__src').on('click', function() {
        $('#video').addClass('has-overlay');
        $('#video').css('display', 'flex');
        $('.video__src')[0].pause();
    });

    if (Modernizr.touchevents) {
        $video.controls = true;
    } else {
        $video.controls = false;
    }
});

  } catch(e) { console.error(e); }
})();
})();
